import {Heading, HStack, useTheme} from '@chakra-ui/react'
import {useRouter} from 'next/router'
import {ROUTE_ROOT} from '../../constants/routes'
import BackButton from '../Molecules/BackButton'

interface Props {
  title: string
}

const GenericHeader = ({title}: Props) => {
  const theme = useTheme()
  const router = useRouter()

  return (
    <HStack w='full' h={14} justify='space-between'>
      <HStack spacing={5}>
        <BackButton onClick={() => router.replace(ROUTE_ROOT)} />
        <Heading as='h1' color={theme.colors.text.basic} variant='large'>
          {title}
        </Heading>
      </HStack>
    </HStack>
  )
}

export default GenericHeader
